'use client'

import React from 'react'
import { ControllerRenderProps } from 'react-hook-form'
import { EditorProvider } from './editor-provider'
import { cn } from '../../lib/utils'
import { FileType } from '@repo/types/common'
import { Editor } from './components/editor-toolbar'

interface RichTextEditorProps {
  field: ControllerRenderProps<any, any>
  placeholder?: string
  userId: number
  className?: string
}

export function RichTextEditor({
  field,
  placeholder,
  userId,
  className,
}: RichTextEditorProps) {
  const handleEditorChange = (value: string) => {
    if (value !== field.value) {
      field.onChange(value)
    }
  }

  return (
    <div className={cn('flex flex-row', className)}>
      <div className="w-full">
        <div className="flex flex-col rounded-[8px] border border-[#0000001a]">
          <EditorProvider
            key={`editor-${field.name}`}
            initialValue={field.value || ''}
            onChange={handleEditorChange}>
            <Editor
              withPreview
              toolbarConfig={{
                withTypo: true,
                withLink: true,
                withUploadImage: { userId, fileType: FileType.IMAGE_EDITOR },
                withVideo: true,
                withButton: true,
                withHeading: true,
                withBulletList: true,
                // #2416: en convocatorias los textos son largos y la barra se perdía
                // al hacer scroll.
                sticky: true,
              }}
              inputConfig={{
                placeholder: placeholder || 'Escribe aquí...',
                onValueChange: (v) => {},
              }}
            />
          </EditorProvider>
        </div>
      </div>
    </div>
  )
}
